<template>
  <div>
    <b-container class="mt-4 mb-4">
      <!-- placeholder tant qu'il n'y a pas de recherche faite (normalement jamais) / chargement -->
      <transition-group v-if="isLoading" appear name="listCustomTransition" tag="div">
        <div key="homePlaceHolder-annoncesClosed" class="mt-5">
          <div class="mb-3">
            <div class="d-flex justify-content-between">
              <h1 class="page-title">{{ $t('CLOSE_ANNONCES') }}</h1>
            </div>
          </div>
          <div class="other-annonces card-container row row-cards-annonces"
               @mousedown="handleMouseDown"
               @mouseleave="handleMouseLeave"
               @mousemove="handleMouseMove"
               @mouseup="handleMouseUp">
            <PlaceholderCardAnnonce :isAnimated=true :isForHome=true :isGradient=false></PlaceholderCardAnnonce>
            <PlaceholderCardAnnonce :isAnimated=true :isForHome=true :isGradient=false></PlaceholderCardAnnonce>
            <PlaceholderCardAnnonce :isAnimated=true :isForHome=true :isGradient=false></PlaceholderCardAnnonce>
            <PlaceholderCardAnnonce :isAnimated=true :isForHome=true :isGradient=false></PlaceholderCardAnnonce>
          </div>
        </div>
        <div key="homePlaceHolder-annoncesLast" class="mt-5">
          <div class="mb-3">
            <div class="d-flex justify-content-between">
              <h1 class="page-title">{{ $t('LAST_ANNONCES') }}</h1>
            </div>
          </div>
          <div class="other-annonces card-container row row-cards-annonces"
               @mousedown="handleMouseDown"
               @mouseleave="handleMouseLeave"
               @mousemove="handleMouseMove"
               @mouseup="handleMouseUp">
            <PlaceholderCardAnnonce :isAnimated=true :isForHome=true :isGradient=false></PlaceholderCardAnnonce>
            <PlaceholderCardAnnonce :isAnimated=true :isForHome=true :isGradient=false></PlaceholderCardAnnonce>
            <PlaceholderCardAnnonce :isAnimated=true :isForHome=true :isGradient=false></PlaceholderCardAnnonce>
            <PlaceholderCardAnnonce :isAnimated=true :isForHome=true :isGradient=false></PlaceholderCardAnnonce>
          </div>
        </div>
      </transition-group>

      <transition-group v-if="!isLoading" name="listCustomTransition">
        <div v-for="(annonceGroup, index) in annonceData" :key="index+'-annonceGroup'" class="mt-5">
          <div class="mb-3">
            <div class="d-flex justify-content-between">
              <h1 class="page-title">{{ annonceGroup.isI18n ? $t(annonceGroup.annonceType) : annonceGroup.title }}</h1>
              <div v-if="annonceGroup.annonceType !== 'CLOSE_ANNONCES'">
                <!-- if à supprimer si on veut le Voir tout sur les annonces proches -->
                <b-button v-if="annonceGroup.annonces.length > 0" class="text-nowrap" variant="primary-only-text"
                          @click="goToSearch(annonceGroup.annonceType, annonceGroup.vehicleTypeId, annonceGroup.savedSearchId,annonceGroup.title)">
                  {{ $t('seeEverything') }}
                </b-button>
              </div>
            </div>
            <div v-if="annonceGroup.savedSearchDescription" class="mt-2 main-grey-medium-color">
              {{ $t('annonce.home.savedSearch.with.filters') }} {{ annonceGroup.savedSearchDescription }}
            </div>
          </div>
          <template v-if="annonceGroup.annonces.length > 0">
            <div v-if="annonceGroup.annonceType === 'LAST_ANNONCES'" class="other-annonces card-container"
                 @mousedown="handleMouseDown"
                 @mouseleave="handleMouseLeave"
                 @mousemove="handleMouseMove"
                 @mouseup="handleMouseUp">
              <annonce-card-image-top v-for="annonce in annonceGroup.annonces" :key="annonce.serverId"
                                      :annonce="annonce" class="cursor-pointer"/>
            </div>
            <div v-else class="last-annonces card-container"
                 @mousedown="handleMouseDown"
                 @mouseleave="handleMouseLeave"
                 @mousemove="handleMouseMove"
                 @mouseup="handleMouseUp">
              <annonce-card-image-left v-for="annonce in annonceGroup.annonces" :key="annonce.serverId"
                                       :annonce="annonce" class="cursor-pointer"/>
            </div>
          </template>
          <template v-else>

            <div class="card-container">
              <div class="d-flex">
                <div class="p-3">
                  <img :src="require(`@/assets/images/b122/img-confused.png`)" alt="no result"
                       class="empty-state-img-home">
                </div>
                <div class="empty-state-text">
                  {{ $t(emptyStateText(annonceGroup.annonceType)) }}
                </div>
              </div>
            </div>

          </template>
        </div>
      </transition-group>
    </b-container>
  </div>
</template>


<script>

import api from '../../services/api'
import AnnonceCardImageTop from "../../components/annonce/AnnonceCardImageTop";
import AnnonceCardImageLeft from "../../components/annonce/AnnonceCardImageLeft";
import PlaceholderCardAnnonce from "../search/PlaceholderCardAnnonce"
import {eventBus} from "../../main";

export default {
  name: 'Home',

  components: {
    AnnonceCardImageLeft,
    AnnonceCardImageTop,
    PlaceholderCardAnnonce,
  },

  data() {
    return {
      isLoading: true,
      user: {
        lat: null,
        lng: null,
      },
      isDown: false,
      startX: 0,
      scrollLeft: 0,
      annonceData: []
    }
  },

  async mounted() {
    eventBus.$emit("checkIdentityValidation", true)
    await this.fetchData()
  },


  methods: {

    async fetchData() {
      await this.getPositionUser()
      await this.fetchAnnonceData()
    },

    async fetchAnnonceData() {

      let data = new FormData();

      if (this.user.lat !== null && this.user.lng !== null) {
        data.append('latitude', this.user.lat);
        data.append('longitude', this.user.lng);
      }

      api({
        method: 'POST',
        url: `/home/getHomeData`,
        data: data
      })
        .then((response) => {
          this.annonceData = response.data;
          this.isLoading = false
        })
        .catch((error) => {

        })
    },

    getPositionUser() {
      return new Promise((resolve) => {
        if (navigator.geolocation) {
          navigator.geolocation.getCurrentPosition((position) => {
            this.setPosition(position)
            resolve()
          }, (error) => {
            console.error("Error getting position:", error)
            resolve() // Résoudre la promesse même en cas d'erreur
          });
        } else {
          console.error("Geolocation is not supported by this browser.")
          resolve() // Résoudre la promesse si la géolocalisation n'est pas supportée
        }
      });
    },


    setPosition(position) {
      this.user.lat = position.coords.latitude
      this.user.lng = position.coords.longitude
    },

    emptyStateText(annonceType) {
      if (annonceType === 'CLOSE_ANNONCES') {
        return "annonce.home.emptyText.close.annonces"
      }
      if (annonceType === 'LAST_ANNONCES') {
        return "annonce.home.emptyText.last.annonces"
      }
      if (annonceType === 'SAVED_SEARCH_ANNONCES') {
        return "annonce.home.emptyText.savedSearch"
      }
      if (annonceType === 'VEHICLE_ANNONCES') {
        return "annonce.home.emptyText.vehicle"
      }
      return ""
    },

    handleMouseDown(e) {
      this.isDown = true;
      this.startX = e.pageX - e.currentTarget.offsetLeft;
      this.scrollLeft = e.currentTarget.scrollLeft;
    },

    handleMouseLeave(e) {
      this.isDown = false;
    },

    handleMouseUp(e) {
      this.isDown = false;
    },

    handleMouseMove(e) {
      if (!this.isDown) return;
      e.preventDefault();
      const x = e.pageX - e.currentTarget.offsetLeft;
      const walk = (x - this.startX) * 3; // Vitesse de défilement
      e.currentTarget.scrollLeft = this.scrollLeft - walk;
    },

    goToSearch(annonceType, vehicleTypeId, savedSearchId, annonceTitle) {
      if (annonceType === 'TOP_ANNONCES') {
        this.$router.push({name: 'TopAnnonces'})
      } else {
        this.$router.push({
          name: 'Search',
          params: {
            annonceType: annonceType,
            vehicleTypeId: vehicleTypeId,
            savedSearchId: savedSearchId,
            savedSearchName: annonceTitle
          }
        })
      }
    },

  }

}

</script>

<style scoped>

.card-container {
  display: flex;
  flex-wrap: nowrap;
  overflow-x: auto;
  -ms-overflow-style: none;
  scrollbar-width: none;
  margin-right: -5px;
  margin-left: -5px;
}

.card-container::-webkit-scrollbar {
  display: none;
}

.other-annonces .card-inside-container {
  flex: 1 1 auto;
  min-width: 250px;
  width: 25%;
  max-width: 25%;
  padding-right: 5px;
  padding-left: 5px;
}

.last-annonces .card-inside-container {
  flex: 1 0 auto;
  min-width: 300px;
  width: 25%;
  max-width: 25%;
  padding-right: 5px;
  padding-left: 5px;
}

.other-annonces .card {
  display: flex;
  align-items: center;
}


.empty-state-text {
  margin-top: 3.5rem;
  max-width: 300px;
}

.row-cards-annonces {
  margin-right: 0.5em;
  margin-top: 0.5em;
  margin-left: -0.5em;
}

</style>



// WEBPACK FOOTER //
// src/views/home/Home.vue